module.exports = "<div users-wrapper page-class=\"users-client\">\n  <ui-view></ui-view>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/client/client.html
// module id = 101
// module chunks = 0